import { useState, useEffect } from 'react'

/**
 * Hook do śledzenia statusu połączenia z internetem
 * @returns {boolean} Status połączenia z internetem (true = online, false = offline)
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 Połączenie z internetem przywrócone')
      setIsOnline(true)
    }

    const handleOffline = () => {
      console.log('🔌 Utracono połączenie z internetem')
      setIsOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return isOnline
}